import { defineStore } from "pinia";
import { computed, shallowRef } from "vue";
import * as services from "@shared/services";
import { getCommonParams } from "@shared/utils/commonParams";
import { formatCartGoods } from "@shared/utils";
import { cloneDeep } from "lodash-es";

const useGoodsStore = defineStore("goods-store", () => {
  const goods = shallowRef([]);

  const flatGoods = computed(() => {
    return formatCartGoods(cloneDeep(goods.value));
  });

  const checkedGoods = computed(() => {
    return flatGoods.value.filter((item) => item._isChecked);
  });

  const getGoodsList = async () => {
    const result = await services.getCartList();
    if (result.t && result.t.vendors) {
      goods.value = cloneDeep(result);
    }

    return result;
  };

  const changeGoodsCheckedById = async ({ id, check }) => {
    const result = await services.activeItem({
      itemId: id,
      active: !!check,
      ...getCommonParams(),
    });

    return result;
  };

  return {
    goods,
    flatGoods,
    checkedGoods,
    getGoodsList,
    changeGoodsCheckedById,
  };
});

export default useGoodsStore;
